import { getTheme } from '@fluentui/react';
import { makeStyles, teamsLightTheme, tokens, } from '@fluentui/react-components';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import { useThemeGenerator } from '@office-start/theming-service';
import React from 'react';
import { CustomMixinButton } from './ThemeExamples/CustomMixinButton';
import { CustomMSButton } from './ThemeExamples/CustomMSButton';
import { FabricMixinButton } from './ThemeExamples/FabricMixinButton';
import { FabricMSButton } from './ThemeExamples/FabricMSButton';
import { FluentMixinButton } from './ThemeExamples/FluentMixinButton';
import { FluentMSButton } from './ThemeExamples/FluentMSButton';
export var ThemeTestToken = function (_a) {
    var token = _a.token, color = _a.color;
    var style = {
        background: color,
        width: 280,
        padding: 8,
    };
    return (React.createElement("div", { style: style },
        React.createElement("div", { style: { color: '#ffffff' } }, token),
        React.createElement("div", { style: { color: '#000000' } }, token)));
};
var useSurface = makeStyles({
    surface: {
        backgroundColor: tokens.colorNeutralBackground1,
        color: tokens.colorNeutralForeground1,
    },
});
var useTeamsText = makeStyles({
    text: {
        color: tokens.colorBrandForeground1,
    },
});
export var ShadowTestToken = function (_a) {
    var token = _a.token, shadow = _a.shadow;
    var style = {
        boxShadow: shadow,
        width: 120,
        height: 120,
        minWidth: 120,
        margin: 8,
        display: 'inline-block',
    };
    var classes = useSurface();
    return (React.createElement("div", { style: style, className: classes.surface },
        React.createElement("div", null, token)));
};
export var FontTestToken = function (_a) {
    var token = _a.token, fontSize = _a.fontSize, lineHeight = _a.lineHeight, fontWeight = _a.fontWeight;
    var style = {
        width: 280,
        padding: 8,
    };
    var classes = useSurface();
    return (React.createElement("div", { style: style, className: classes.surface },
        React.createElement("div", { style: {
                lineHeight: lineHeight,
                fontSize: fontSize,
                fontWeight: fontWeight,
            } }, token)));
};
var textTokens = [
    {
        name: 'caption2',
        fontSizeKey: 'fontSizeBase100',
        lineHeightKey: 'lineHeightBase100',
        fontWeightKey: 'fontWeightRegular',
    },
    {
        name: 'caption2Strong',
        fontSizeKey: 'fontSizeBase100',
        lineHeightKey: 'lineHeightBase100',
        fontWeightKey: 'fontWeightSemibold',
    },
    {
        name: 'caption1',
        fontSizeKey: 'fontSizeBase200',
        lineHeightKey: 'lineHeightBase200',
        fontWeightKey: 'fontWeightRegular',
    },
    {
        name: 'caption1Strong',
        fontSizeKey: 'fontSizeBase200',
        lineHeightKey: 'lineHeightBase200',
        fontWeightKey: 'fontWeightSemibold',
    },
    {
        name: 'body1',
        fontSizeKey: 'fontSizeBase300',
        lineHeightKey: 'lineHeightBase300',
        fontWeightKey: 'fontWeightRegular',
    },
    {
        name: 'body1Strong',
        fontSizeKey: 'fontSizeBase300',
        lineHeightKey: 'lineHeightBase300',
        fontWeightKey: 'fontWeightSemibold',
    },
    {
        name: 'subtitle2',
        fontSizeKey: 'fontSizeBase400',
        lineHeightKey: 'lineHeightBase400',
        fontWeightKey: 'fontWeightSemibold',
    },
    {
        name: 'subtitle1',
        fontSizeKey: 'fontSizeBase500',
        lineHeightKey: 'lineHeightBase500',
        fontWeightKey: 'fontWeightSemibold',
    },
    {
        name: 'title3',
        fontSizeKey: 'fontSizeBase600',
        lineHeightKey: 'lineHeightBase600',
        fontWeightKey: 'fontWeightSemibold',
    },
    {
        name: 'title2',
        fontSizeKey: 'fontSizeHero700',
        lineHeightKey: 'lineHeightHero700',
        fontWeightKey: 'fontWeightSemibold',
    },
    {
        name: 'title1',
        fontSizeKey: 'fontSizeHero800',
        lineHeightKey: 'lineHeightHero800',
        fontWeightKey: 'fontWeightSemibold',
    },
    {
        name: 'largeTitle',
        fontSizeKey: 'fontSizeHero900',
        lineHeightKey: 'lineHeightHero900',
        fontWeightKey: 'fontWeightSemibold',
    },
    {
        name: 'display',
        fontSizeKey: 'fontSizeHero1000',
        lineHeightKey: 'lineHeightHero1000',
        fontWeightKey: 'fontWeightSemibold',
    },
];
export var ThemeTestPage = function () {
    var aliases = Object.keys(tokens).filter(function (key) { return key.startsWith('color') && !key.startsWith('colorPalette'); });
    var swatches = aliases.map(function (key) {
        return (React.createElement(ThemeTestToken, { key: key, token: key, color: tokens[key] }));
    });
    var colorMatrix = aliases.map(function (key) {
        var style = {
            background: tokens[key],
            width: 20,
            height: 20,
            lineHeight: '20px',
            display: 'inline-block',
            fontSize: 8,
        };
        return (React.createElement("span", { style: style, key: key }, key.replace(/[a-z]/g, '')));
    });
    var legacyPalette = getTheme().palette;
    var legacyThemes = Object.keys(legacyPalette).map(function (key) {
        return (React.createElement(ThemeTestToken, { key: key, token: key, color: legacyPalette[key] }));
    });
    var shadow = Object.keys(tokens).filter(function (key) {
        return key.startsWith('shadow');
    });
    var shadows = shadow.map(function (key) {
        return (React.createElement(ShadowTestToken, { key: key, token: key, shadow: tokens[key] }));
    });
    var fonts = textTokens.map(function (token) {
        return (React.createElement(FontTestToken, { key: token.name, token: token.name, lineHeight: tokens[token.lineHeightKey], fontSize: tokens[token.fontSizeKey], fontWeight: tokens[token.fontWeightKey] }));
    });
    var teamsTextStyle = useTeamsText();
    var nestedThemeClass = useThemeGenerator();
    return (React.createElement("div", { id: "themeTestPage" },
        React.createElement("h1", null, "Theme test page"),
        React.createElement("h2", null, "Colors"),
        React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
            React.createElement("div", null,
                React.createElement("div", null, "vNext Design Tokens"),
                React.createElement("div", null, swatches)),
            React.createElement("div", null,
                React.createElement("div", null, "Legacy Palette"),
                React.createElement("div", null, legacyThemes))),
        React.createElement("div", { id: "themeTestColors" },
            React.createElement(OfficeFluentProvider, { theme: teamsLightTheme },
                React.createElement("div", { className: teamsTextStyle.text },
                    React.createElement("h2", null, "Color Matrix")),
                React.createElement("div", { className: nestedThemeClass, style: { width: 500 } }, colorMatrix))),
        React.createElement("div", { id: "themeTestShadows" },
            React.createElement("h2", null, "Shadows"),
            shadows),
        React.createElement("div", { id: "themeTestTypography" },
            React.createElement("h2", null, "Typography"),
            React.createElement("div", null, fonts)),
        React.createElement("h2", null, "Examples"),
        React.createElement("table", null,
            React.createElement("tr", null,
                React.createElement("th", null, "Application"),
                React.createElement("th", null, "Custom"),
                React.createElement("th", null, "Fluent v7"),
                React.createElement("th", null, "Fluent vNext")),
            React.createElement("tr", null,
                React.createElement("td", null, "Mixin"),
                React.createElement("td", null,
                    React.createElement(CustomMixinButton, null)),
                React.createElement("td", null,
                    React.createElement(FabricMixinButton, null)),
                React.createElement("td", null,
                    React.createElement(FluentMixinButton, null))),
            React.createElement("tr", null,
                React.createElement("td", null, "MakeStyles"),
                React.createElement("td", null,
                    React.createElement(CustomMSButton, null)),
                React.createElement("td", null,
                    React.createElement(FabricMSButton, null)),
                React.createElement("td", null,
                    React.createElement(FluentMSButton, null))))));
};
//# sourceMappingURL=ThemeTestPage.js.map